import NavBar, { NavBarProps } from "../components/NavBar";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import BaseScreen from "../screen/BaseScreen";
import { Text, View, TouchableOpacity, Linking, Platform } from "react-native";
import { useAppNavigation } from "../screen/navigation";

export interface WebController {
    reload: () => void;
    goBack: () => void;
    goForward: () => void;
}

type WebComponentProps = {
    title?: string;
    url: string;
    navProps: NavBarProps;
};

export const WebComponent = forwardRef<WebController, WebComponentProps>(({ title, url, navProps }, ref) => {
    const [webUrl, setWebUrl] = useState('');
    const nav = useAppNavigation();

    useEffect(() => {
        if (url) {
            const isValidUrl = /^https?:\/\//i.test(url);
            // 如果不是有效的 URL 格式，补充 http://
            const formattedUrl = isValidUrl ? url : `http://${url}`;
            setWebUrl(formattedUrl);
        }
    }, [url]);

    const handleOpenUrl = () => {
        if (webUrl) {
            if (Platform.OS === 'web') {
                // Web 平台：在新窗口打开
                window.open(webUrl, '_blank', 'noopener,noreferrer');
            } else {
                // 移动平台：使用 Linking API
                Linking.openURL(webUrl).catch(err => {
                    console.error('Failed to open URL:', err);
                });
            }
        }
    };

    const goBack = () => {
        navProps.backClick ? navProps.backClick() : nav.goBack();
    };

    const goForward = () => {
        // Web 平台不支持前进，移动平台可以
        console.log('goForward not supported in Web');
    };

    const reload = () => {
        // 重新打开链接
        handleOpenUrl();
    };

    // 🔑 把方法暴露出去
    useImperativeHandle(ref, () => ({ reload, goBack, goForward }));

    return (
        <BaseScreen>
            <NavBar {...navProps} title={title} backClick={goBack} />
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20 }}>
                <Text style={{ fontSize: 16, marginBottom: 20, textAlign: 'center', color: '#333' }}>
                    点击下方按钮在新窗口打开链接
                </Text>
                <Text style={{ fontSize: 14, marginBottom: 30, textAlign: 'center', color: '#666' }}>
                    {webUrl}
                </Text>
                <TouchableOpacity
                    onPress={handleOpenUrl}
                    style={{
                        backgroundColor: '#007AFF',
                        paddingHorizontal: 30,
                        paddingVertical: 15,
                        borderRadius: 8,
                    }}
                >
                    <Text style={{ color: '#fff', fontSize: 16, fontWeight: 'bold' }}>
                        在新窗口打开
                    </Text>
                </TouchableOpacity>
            </View>
        </BaseScreen>
    );
});